import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import gallery18 from "../../../assets/training/img_18.jpg";

const Details = () => {
  return (
    <Box margin={{ xs: "25% 0% 10% 0%", sm: "5% 0% 2% 0%" }}>
      <Typography
        variant="h3"
        color="#00AEEF"
        fontWeight={900}
        paddingBottom={"3%"}
        textAlign={"left"}
      >
        Training Institute
      </Typography>
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "50%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "10%", sm: "0%" }}
        >
          <Box
            component="img"
            height={{ xs: "40vh", sm: "560px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={gallery18}
            alt={"training-img"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Box>
        <Box
          width={{ xs: "100%", sm: "45%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "10%", sm: "0%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            Aquatic Hub Afrique Network Limited offers several courses targeted
            towards multiple value chains of the Aquaculture industry. Some of
            these courses are:
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>
            Introduction to Aquaculture (AQU 1000)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>
            Aquaculture Enterprise Development (AQU 5000)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>{" "}
            Water Quality Management (AQU 5010)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>{" "}
            Fish Breeding (AQU 5020)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>{" "}
            Fish Processing (FSP 6030)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            {" "}
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>
            Fish Value Addition (FSP 6040)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>{" "}
            Fabrication of Fish Gears 1 (TCN 6100)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>{" "}
            Fabrication of Fish Gears 2 (TCN 6110)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>{" "}
            Aquarium Design and Construction (ADC 6200)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>{" "}
            Ornamental Fish Farming (OFF 6210)
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Details;
